module.exports = __webpack_public_path__ + "static/img/icon_code_04.f8aa456.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/index/icon_code_04.png
// module id = CrV1
// module chunks = 11